import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SelectItem } from 'primeng/primeng';
import { environment } from '../../../environments/environment';
import { StrtKeyMeasure } from '../../shared/models/plan/StrtKeyMeasure';
import {StrtCreateKeyMeasures} from '../../shared/models/api/StrtCreateKeyMeasures';

@Injectable()
export class KeyMeasureService {
  private baseUrl = environment.baseUrl;

  constructor(private http: HttpClient) { }

  static keyMeasureOptions(measures: StrtKeyMeasure[]): SelectItem[] {
    return measures.map((measure) => {
      return {label: measure.measure, value: measure};
    });
  }

  createKeyMeasures(strategyId: number, initiativeId: number, payload: StrtCreateKeyMeasures): Observable<any> {
    return this.http.post<StrtKeyMeasure[]>(this.resourcesUrl(strategyId, initiativeId), payload);
  }

  updateKeyMeasure(strategyId: number, initiativeId: number, keyMeasure: StrtKeyMeasure): Observable<StrtKeyMeasure> {
    return this.http.put<StrtKeyMeasure>(`${this.resourcesUrl(strategyId, initiativeId)}/${keyMeasure.keyMeasureId}`,
      keyMeasure);
  }

  /**
   * Endpoint is used only to delete key measures that have only 1 association
   * @param {number} strategyId
   * @param {StrtKeyMeasure} keyMeasure
   * @returns {Observable<{}>}
   */
  deleteKeyMeasure(strategyId: number, keyMeasure: StrtKeyMeasure): Observable<{}> {
    return this.http.delete<{}>(`${this.resourcesUrl(strategyId, keyMeasure.initiativeId)}/${keyMeasure.keyMeasureId}`);
  }

  /**
   * Endpoint is used only to delete key measures that have more that 1 association
   * @param {number} strategyId
   * @param {StrtKeyMeasure} keyMeasure
   * @returns {Observable<{}>}
   */
  deleteReusedKeyMeasure(strategyId: number, keyMeasure: StrtKeyMeasure): Observable<{}> {
    return this.http.delete<{}>(
      `${this.resourcesUrl(strategyId, keyMeasure.initiativeId)}/${keyMeasure.keyMeasureId}?allAssociations=true`);
  }

  validateKeyMeasureUniqueness(strategyId: number, initiativeId: number, keyMeasureText: string): Observable<boolean> {
    return this.http.post<boolean>(`${this.resourcesUrl(strategyId, initiativeId)}/duplicateCheck`, keyMeasureText);
  }

  private resourcesUrl(strategyId: number, initiativeId: number) {
    return `${this.baseUrl}/strategies/${strategyId}/initiatives/${initiativeId}/keymeasures`;
  }
}
